import { endpoints } from '@/config';
import get from './get';

export default async function getTelemetryLatest(accountId) {
  const resource = '/latest';
  const overrides = {
    method: 'GET',
    url: `${endpoints.telemetry}${resource}`,
  };
  return get(overrides, { accountId }, { resource });
}
